import Marquee from "react-fast-marquee";

const words = ["Weddings", "Sangeet", "Decor & Design", "Catering", "Corporate Galas", "Birthdays", "Anniversaries", "Entertainment", "Destination Weddings"];

export default function OccasionsMarquee() {
  return (
    <section data-testid="marquee-section" className="bg-heirloom-maroon py-5 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-heirloom-bone text-2xl md:text-3xl px-10">{w}</span>
            <span className="text-heirloom-gold-light text-lg">&#10022;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
